var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c(
          "table",
          { staticClass: "table table-bordered table-happy nomargin" },
          [
            _vm._m(1),
            _c(
              "tbody",
              [
                _vm.listBillOfLading.length > 0
                  ? _vm._l(_vm.listBillOfLading, function(bill, index) {
                      return _c("tr", { key: bill.id }, [
                        _c("td", [_vm._v(_vm._s(index + 1))]),
                        _c("td", [_vm._v(_vm._s(bill.orderTransactionCode))]),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(bill.weight) +
                              "\n                        "
                          )
                        ]),
                        _c("td", { staticClass: "col-status text-center" }, [
                          _c(
                            "label",
                            {
                              staticClass: "lb-status",
                              style: {
                                "background-color": bill.statusDetail.color
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(bill.statusDetail.name) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ])
                    })
                  : _vm._e(),
                !(_vm.listBillOfLading.length > 0) ? [_vm._m(2)] : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Danh sách vận đơn")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w45" }),
        _c("th", { staticClass: "w250" }, [_vm._v("Mã vận đơn")]),
        _c("th", { staticClass: "text-center" }, [_vm._v("Cân nặng")]),
        _c("th", { staticClass: "w180 text-center" }, [_vm._v("Trạng thái")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td", { attrs: { colspan: "4" } })])
  }
]
render._withStripped = true

export { render, staticRenderFns }